<template>
<div class="chapter">
<div class="inner_page">
<div class="image" id="image1">
<p class="center"><img alt="" src="images/image-7.jpg"/></p>
</div>
<h1>DEDICATION</h1>
<p class="center">To the ones who loved me just for being Michael.</p>
<p class="center">And to all who made my journey possible …</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004dedication.vue?79e0b16e